import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
import {
	Fancybox
} from "@fancyapps/ui";
import Flickity from "flickity";
import "flickity-fade";
import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});

AOS.init({
	once: true,
	duration: 600, // values from 0 to 3000, with step 50ms
	easing: 'ease-in-out',
	initClassName: false,
	//animatedClassName: 'animated',
});

jQuery(function ($) {
	$('svg[data-control]').on('click', function () {
		var target = $(this).data('controls'),
			direction = $(this).data('control'),
			flkty = Flickity.data(target);

		if (direction == 'next') {
			flkty.next();
		} else if (direction == 'previous') {
			flkty.previous();
		}
	});
});